import { IPromotionsClient } from './IPromotionsClient';
import { PromotionsClientApi } from './promotionsClientApi';

export * from './IPromotionsClient';
export * from './promotionTypes';

// Promotions has a real backend (routes-promotions.json) — always use the real client.
export const promotionsClient: IPromotionsClient = new PromotionsClientApi();
